/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessUnitScopeFilter } from './businessUnitScopeFilter';
import { BusinessUnitIncludeFilterItems } from './businessUnitIncludeFilterItems';


export interface BusinessUnitIncludeFilterInner { 
    relation?: BusinessUnitIncludeFilterInner.RelationEnum;
    scope?: BusinessUnitScopeFilter;
}
export namespace BusinessUnitIncludeFilterInner {
    export type RelationEnum = 'company';
    export const RelationEnum = {
        Company: 'company' as RelationEnum
    };
}


